<div class="lead-info-container">
    <!-- Header -->
    <div class="lead-info-header">
        <div class="header-left">
            <mat-icon svgIcon="human" class="header-icon"></mat-icon>
            <span class="header-title">Lead Info</span>
        </div>
        <button class="collapse-btn" (click)="toggleCollapse()">
            <mat-icon>{{ isCollapsed ? 'add' : 'remove' }}</mat-icon>
        </button>
    </div>

    <!-- Body -->
    <div class="lead-info-body" *ngIf="!isCollapsed">

        <!-- Profile Row -->
        <div class="profile-row">
            <div class="profile-left">
                <div class="profile-main">
                    <div class="avatar">{{ leadInfo.clientInitials }}</div>
                    <div class="profile-details">
                        <div class="client-name-row">
                            <button type="button" class="client-name-button" (click)="openLeadDetails()">
                                <app-tooltip class="lead-info-tooltip lead-info-tooltip--client" [text]="leadInfo.clientName" [disabled]="!isTextOverflowing(clientNameElement)" position="above">
                                    <span #clientNameElement class="client-name">{{ leadInfo.clientName }}</span>
                                </app-tooltip>
                            </button>
                            <mat-icon svgIcon="icon-link" class="link-icon"></mat-icon>
                        </div>
                        <div class="lead-id-row">
                            <span class="lead-id-label">Lead ID:</span>
                            <app-tooltip class="lead-info-tooltip lead-info-tooltip--lead-id" [text]="leadInfo.leadId" [disabled]="!isTextOverflowing(leadIdElement)" position="above">
                                <span #leadIdElement class="lead-id-badge">{{ leadInfo.leadId }}</span>
                            </app-tooltip>
                        </div>
                    </div>
                </div>
                <div class="last-activity">
                    <mat-icon svgIcon="icon-clock" class="activity-icon"></mat-icon>
                    <span class="activity-text">
                        Last Activity: {{ leadInfo.lastActivityText }}
                        <ng-container *ngIf="leadInfo.lastActivityTime">({{ leadInfo.lastActivityTime }})</ng-container>
                    </span>
                </div>
            </div>

            <!-- Info Cards Grid -->
            <div class="info-cards-grid">
                <!-- Quote Reference (clickable) -->
                <button type="button" class="info-card info-card--clickable" (click)="onQuoteReferenceClick()">
                    <mat-icon svgIcon="quote-product-library" class="card-icon"></mat-icon>
                    <div class="card-content">
                        <span class="card-label" title="Quote Reference">Quote Reference</span>
                        <div class="card-value-row">
                            <app-tooltip class="lead-info-tooltip lead-info-tooltip--row-value" [text]="leadInfo.quoteReference" [disabled]="!isTextOverflowing(quoteReferenceElement)" position="above">
                                <span #quoteReferenceElement class="card-value">{{ leadInfo.quoteReference }}</span>
                            </app-tooltip>
                            <span class="version-badge">{{ leadInfo.quoteVersion }}</span>
                            <mat-icon svgIcon="icon-external-link" class="external-link-icon"></mat-icon>
                        </div>
                    </div>
                </button>

                <!-- Insurance Quote Popup Modal -->
                <app-popup-modal *ngIf="showQuoteModal" class="view-modal-popup" [width]="'1000px'"
                    (closePopupModal)="closeQuoteModal()">
                    <div custom-content-below class="view-popup-content view-popup-content--insurance scrollable">
                        <div class="summary-card__body">
                            <div class="summary-card__illustration">
                                <mat-icon class="summary-card__illustration-icon"
                                    svgIcon="icon-maf-insurance-quote"></mat-icon>
                            </div>
                            <div class="summary-card__title-block">
                                <h2 class="summary-card__title">Selected Insurance Quote</h2>
                            </div>
                        </div>
                        <app-maf-insurer-tile [isPreviewMode]="true" [productId]="productId" [leadInfoId]="leadInfoId"
                            [quoteVersion]="leadInfo.quoteVersion"></app-maf-insurer-tile>
                    </div>
                </app-popup-modal>

                <!-- Insurer -->
                <div class="info-card">
                    <mat-icon svgIcon="icon-hospital" class="card-icon"></mat-icon>
                    <div class="card-content">
                        <span class="card-label" title="Insurer">Insurer</span>
                        <app-tooltip class="lead-info-tooltip" [text]="leadInfo.insurer" [disabled]="!isTextOverflowing(insurerElement)" position="above">
                            <span #insurerElement class="card-value">{{ leadInfo.insurer }}</span>
                        </app-tooltip>
                    </div>
                </div>

                <!-- Plan Name -->
                <div class="info-card">
                    <mat-icon svgIcon="quote-plan" class="card-icon"></mat-icon>
                    <div class="card-content">
                        <span class="card-label" title="Plan Name">Plan Name</span>
                        <app-tooltip class="lead-info-tooltip" [text]="leadInfo.planName" [disabled]="!isTextOverflowing(planNameElement)" position="above">
                            <span #planNameElement class="card-value">{{ leadInfo.planName }}</span>
                        </app-tooltip>
                    </div>
                </div>

                <!-- Network -->
                <div class="info-card">
                    <mat-icon svgIcon="quote-network" class="card-icon"></mat-icon>
                    <div class="card-content">
                        <span class="card-label" title="Network">Network</span>
                        <app-tooltip class="lead-info-tooltip" [text]="leadInfo.network" [disabled]="!isTextOverflowing(networkElement)" position="above">
                            <span #networkElement class="card-value">{{ leadInfo.network }}</span>
                        </app-tooltip>
                    </div>
                </div>

                <!-- Lead Created On -->
                <div class="info-card">
                    <mat-icon svgIcon="icon-calendar" class="card-icon"></mat-icon>
                    <div class="card-content">
                        <span class="card-label" title="Lead Created On">Lead Created On</span>
                        <app-tooltip class="lead-info-tooltip" [text]="leadInfo.leadCreatedOn" [disabled]="!isTextOverflowing(leadCreatedOnElement)" position="above">
                            <span #leadCreatedOnElement class="card-value">{{ leadInfo.leadCreatedOn }}</span>
                        </app-tooltip>
                    </div>
                </div>

                <!-- No. of Applicants -->
                <div class="info-card">
                    <mat-icon svgIcon="insurance-category" class="card-icon"></mat-icon>
                    <div class="card-content">
                        <span class="card-label" title="No. of Applicants">No. of Applicants</span>
                        <app-tooltip class="lead-info-tooltip" [text]="leadInfo.noOfApplicants.toString()" [disabled]="!isTextOverflowing(applicantsElement)" position="above">
                            <span #applicantsElement class="card-value">{{ leadInfo.noOfApplicants }}</span>
                        </app-tooltip>
                    </div>
                </div>

                <!-- Assigned Agent -->
                <div class="info-card">
                    <mat-icon svgIcon="human-outline" class="card-icon"></mat-icon>
                    <div class="card-content">
                        <span class="card-label" title="Assigned Agent">Assigned Agent</span>
                        <div class="card-value-row">
                            <app-tooltip class="lead-info-tooltip lead-info-tooltip--row-value" [text]="leadInfo.assignedAgent" [disabled]="!isTextOverflowing(assignedAgentElement)" position="above">
                                <span #assignedAgentElement class="card-value agent-name">{{ leadInfo.assignedAgent }}</span>
                            </app-tooltip>
                            <mat-icon svgIcon="icon-headset-support" class="agent-icon"></mat-icon>
                        </div>
                    </div>
                </div>

                <!-- Assigned Reviewer -->
                <div class="info-card" [class.reviewer-unassigned]="isUnassignedReviewer">
                    <mat-icon svgIcon="extract" class="card-icon"></mat-icon>
                    <div class="card-content">
                        <span class="card-label" title="Assigned Reviewer">Assigned Reviewer</span>
                        <app-tooltip class="lead-info-tooltip" [text]="leadInfo.assignedReviewer" [disabled]="!isTextOverflowing(assignedReviewerElement)" position="above">
                            <span #assignedReviewerElement class="card-value">{{ leadInfo.assignedReviewer }}</span>
                        </app-tooltip>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>